import { render, staticRenderFns } from "./servizi.vue?vue&type=template&id=6d14098b"
import script from "./servizi.vue?vue&type=script&lang=js"
export * from "./servizi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports